import { createCanvas } from '@/utils/helpers/train-simulation/create-canvas';

export const createCircleAtlas = (size: number): string => {
  const res = createCanvas(size * 2, size * 2);

  if (!res?.ctx) {
    return '';
  }

  const { ctx, canvas } = res;

  ctx.beginPath();
  ctx.arc(size, size, size - 1, 0, Math.PI * 2);
  ctx.fillStyle = '#FFFFFF';
  ctx.fill();

  return canvas.toDataURL();
};
